<template>
    <a v-if="number" :href="phoneNumber">{{ number }}</a>
</template>
<script>
    export default {
        props: {
            number: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                rules: [
                    { replace: /\+/g, with: '00'},
                    { replace: /\ /g, with: ''},
                ]
            }
        },
        computed: {
            phoneNumber() {
                let number = this.number;

                for(let rule of this.rules) {
                    number = number.replace(rule.replace, rule.with)
                }

                return 'tel://' + number
            }
        }
    }
</script>
<style lang="scss">
    
</style>